import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Route, Routes } from "react-router";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";
import { stores } from "./stores";
import ErrorBoundary from "./components/ErrorBoundary";
import Layout from "./components/Layout";
import ToastContextProvider from "./contexts/toast-context";
import { setCurrentUser, setPulseAccountId, setAWSRegions } from "./features/auth/authSlice";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import { Endpoints, LazyFileBrowserPage, LazyLoginPage, LazyMagicLinkSignInPage, LazyNotFoundPage, LazySetupDeliveryPage, } from "./routes";
import SessionExpiredDialog from "./features/auth/logout/components/SessionExpiredDialog";
import { PulseUserType } from "./features/auth/models/authModels";
import "./App.css";
const App = (props) => {
    var _a;
    const isAdmin = ((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.type) === PulseUserType.ADMIN;
    return (_jsxs(ErrorBoundary, { children: [_jsx(Routes, { children: _jsxs(Route, Object.assign({ element: _jsx(Layout, {}) }, { children: [_jsxs(Route, Object.assign({ element: _jsx(PublicRoute, {}) }, { children: [_jsx(Route, { index: true, element: _jsx(LazyLoginPage, {}) }), _jsx(Route, { path: Endpoints.MAGIC_LINK_SIGN_IN, element: _jsx(LazyMagicLinkSignInPage, {}) })] })), _jsxs(Route, Object.assign({ element: _jsx(ProtectedRoute, {}) }, { children: [_jsx(Route, { path: Endpoints.FILE_BROWSER, element: _jsx(LazyFileBrowserPage, {}) }), isAdmin && (_jsx(Route, { path: Endpoints.SETUP_DELIVERY, element: _jsx(LazySetupDeliveryPage, {}) }))] })), _jsx(Route, { path: Endpoints.CATCH_ALL, element: _jsx(LazyNotFoundPage, {}) })] })) }), _jsx(SessionExpiredDialog, {})] }));
};
const PulseApp = (props) => {
    const { currentUser, pulseAccountId, awsRegions } = props;
    if (currentUser) {
        stores.dispatch(setCurrentUser(currentUser));
    }
    if (pulseAccountId) {
        stores.dispatch(setPulseAccountId(pulseAccountId));
    }
    if (awsRegions) {
        stores.dispatch(setAWSRegions(awsRegions));
    }
    return (_jsx(BrowserRouter, { children: _jsx(Provider, Object.assign({ store: stores }, { children: _jsx(PrimeReactProvider, { children: _jsx(ToastContextProvider, { children: _jsx(App, Object.assign({}, props)) }) }) })) }));
};
export default PulseApp;
